import React from 'react';
import { LetterInput } from './LetterInput';

interface WordRowProps {
  letters: string[];
  onChange: (letters: string[]) => void;
  disabled?: boolean;
  label?: string;
  color?: string;
}

export const WordRow: React.FC<WordRowProps> = ({
  letters,
  onChange,
  disabled = false,
  label,
  color,
}) => {
  const handleLetterChange = (index: number, value: string) => {
    const newLetters = [...letters];
    newLetters[index] = value;
    onChange(newLetters);
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '6px 0',
      gap: '8px',
    }}>
      {label && (
        <span style={{
          fontSize: '12px',
          color: '#818384',
          minWidth: '52px',
          textAlign: 'right',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }}>
          {label}
        </span>
      )}
      <div style={{ display: 'flex', gap: '4px' }}>
        {letters.map((letter, index) => (
          <LetterInput
            key={index}
            value={letter}
            onChange={(value) => handleLetterChange(index, value)}
            disabled={disabled}
            color={color}
          />
        ))}
      </div>
    </div>
  );
};
